import { en_US } from './en_US';
import { es_ES } from './es_ES';
import { fr_FR } from './fr_FR';

// Import all input language files
import { ar_AR } from './inputLanguages/ar_AR';
import { de_DE } from './inputLanguages/de_DE';
import { en_US as inputLanguages_en_US } from './inputLanguages/en_US';
import { es_ES as inputLanguages_es_ES } from './inputLanguages/es_ES';
import { fr_FR as inputLanguages_fr_FR } from './inputLanguages/fr_FR';
import { hi_HI } from './inputLanguages/hi_HI';
import { ko_KO } from './inputLanguages/ko_KO';
import { nl_NL } from './inputLanguages/nl_NL';
import { pt_PT } from './inputLanguages/pt_PT';
import { sw_SW } from './inputLanguages/sw_SW';
import { ur_UR } from './inputLanguages/ur_UR';
import { zh_CN } from './inputLanguages/zh_CN';
import { zh_TW } from './inputLanguages/zh_TW';

const languages = {
    en_US,
    es_ES,
    fr_FR
};

const inputLanguages = {
    ar_AR,
    de_DE,
    en_US: inputLanguages_en_US,
    es_ES: inputLanguages_es_ES,
    fr_FR: inputLanguages_fr_FR,
    hi_HI,
    ko_KO,
    nl_NL,
    pt_PT,
    sw_SW,
    ur_UR,
    zh_CN,
    zh_TW
};

export { languages, inputLanguages };